import angular = require("angular");
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import NotificationService from "../../../common/services/notification/notification.service";
import { PackageThumbnail, PriceDetails } from "../../../common/services/package/package.model";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import { GoToOffersAction } from "../../components/go-to-offers-dialog/go-to-offers-dialog.action";
import { OtpAction } from "../../components/otp-dialog/otp-dialog.action";
import NoAuthService from "../../services/noauth.service";
import StorageService from "../../services/storage.service";
import UserInfoService from "../../services/user-info.service";

export default class InvalidController {
  private msisdn;
  private valid: boolean;
  private packet: PackageThumbnail;

  private msisdnError = false;
  public priceDetails: PriceDetails;
  private packetPrice: string;

  constructor(
    private $window,
    private $translate,
    private $sce,
    private $stateParams,
    private $location,
    private noAuthService: NoAuthService,
    private storageService: StorageService,
    private globalSpinner: GlobalSpinnerService,
    private actionDispatcher: ActionDispatcherService,
    private notificationService: NotificationService,
    private userInfoService: UserInfoService
  ) { }


  public $onInit() {
    if (angular.isUndefined(this.packet)) {
      return;
    }

    if (!!this.$stateParams.msisdn) {
      this.checkOTP(this.$stateParams.msisdn);
    }

    if (!!this.$stateParams.promocode) {
      angular.element("#promocode").val(this.$stateParams.promocode);
    }

    this.loadTranslations();
    document.querySelector("#msisdnBuy").addEventListener("keydown", (e) => this.handleKeydownEvent(e));
  }

  public sendOTP() {
    if (this.checkMsisdnField()) {
      this.globalSpinner.startIfNotActivated();
      var tmpMsisdn = this.getMsisdn();
      this.noAuthService.sendOTP(tmpMsisdn).then(result => {
        if (result) {
          this.actionDispatcher.dispatch(new OtpAction(tmpMsisdn, () => this.afterValidation(tmpMsisdn)));
        } else {
          this.showWarning('noAuth.otp.code.resendError');
        }
        this.globalSpinner.stop();
      });
    }
  }

  private checkOTP(msisdn: string) {
    if (msisdn.charAt(0) === "5" && msisdn.length === 10) {
      this.globalSpinner.startIfNotActivated();
      this.noAuthService.checkOTP(msisdn).then(result => {
        if (result) {
          this.afterValidation(msisdn);
        } else {
          this.msisdn = msisdn;
          angular.element("#msisdnBuy").val(msisdn)
          this.checkMsisdnField();
        }
        this.globalSpinner.stop();
      });
    }
    this.$location.search('msisdn', null);
  }

  private async afterValidation(msisdn) {
    this.globalSpinner.startIfNotActivated();
    this.msisdn = msisdn;
    this.storageService.setMsisdn(this.msisdn);

    await this.userInfoService.initiateAllUserInfo(this.msisdn, (key) => this.showWarning(key));
    var offerable = this.userInfoService.checkOfferables(this.packet.id);
    this.globalSpinner.stop();
    if (offerable === "") {
      this.valid = true;
    } else {
      this.actionDispatcher.dispatch(new GoToOffersAction(this.msisdn, offerable));
    }
  }

  private showWarning(translateKey: string) {
    translateKey = (translateKey === "") ? 'error.message.default' : translateKey;
    this.$translate(translateKey).then(value => {
      this.notificationService.showNotification({
        text: value,
        type: 'warning'
      });
    });
  }

  private loadTranslations() {
    var translateKey =
      !this.priceDetails ||
        !this.priceDetails.pricePeriod ||
        this.priceDetails.pricePeriod === 'monthly'
        ? 'packet.period'
        : 'packet.periodYear';
    this.$translate(translateKey, this.packet).then(value => {
      this.packetPrice = this.$sce.trustAsHtml(value);
    });
  }

  private checkMsisdnField(): boolean {
    this.storageService.removeMsisdn();
    var msisdn = this.getMsisdn();
    if (msisdn.charAt(0) === "5" && msisdn.length === 10) {
      this.toggleMsisdnError(false);
      return true;
    }
    this.toggleMsisdnError(true);
    return false;
  }

  private getMsisdn(): string {
    return String(this.msisdn);
  }

  public handleKeydownEvent(e: any) {
    if (e.key === "Enter") {
      this.sendOTP();
    }
  }

  public toggleMsisdnError(toggle: boolean) {
    if (toggle) {
      angular.element("#msisdnField").addClass("form-field--error");
      this.msisdnError = true;
    } else {
      angular.element("#msisdnField").removeClass("form-field--error");
      this.msisdnError = false;
    }
  }

  public overlayClick() {
    this.toggleMsisdnError(true);
    document.getElementById("msisdnBuy").focus();
    this.$window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// src/app/no-auth/buy/invalid/invalid.controller.ts